import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { HoverNotificationComponent } from '@components/shared/hover-notification/hover-notification.component';
import { EmpyreanLoaderModule } from '@core/empyrean-loader/empyrean-loader.module';
import { KendoModule } from '@core/kendo/kendo.module';
import { SharedModule } from '@progress/kendo-angular-dialog';
import { DialogComponent } from './dialog.component';
import { OpenMainDialogDirective } from './open-main-dialog.directive';

@NgModule({
  declarations: [DialogComponent, OpenMainDialogDirective, HoverNotificationComponent],
  entryComponents: [DialogComponent],
  imports: [CommonModule, RouterModule, MatTooltipModule, KendoModule, SharedModule, MatDialogModule, EmpyreanLoaderModule],
  exports: [DialogComponent, OpenMainDialogDirective]
})
export class DialogModule {}
